import { render, staticRenderFns } from "./TextUnderlineIcon.vue?vue&type=template&id=294a4498&"
import script from "./TextUnderlineIcon.vue?vue&type=script&lang=js&"
export * from "./TextUnderlineIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports